const account = {
    accountInformation: 'Informazioni Account',
    emailAddress: 'Indirizzo email',
    username: 'Nome utente',
    yourPlan: 'Il Tuo Piano',
    about: 'Chi Sono',
    aboutDescription: 'Sono un cliente fantastico.',
    creditsRemaining: 'Crediti rimanenti',
    buyMoreUpgrade: 'Acquista di Più/Aggiorna',
    manageSubscription: 'Gestisci Abbonamento',
    logout: 'Esci',
    logoutConfirmation: 'Conferma Uscita',
    logoutConfirmMessage: 'Sei sicuro di voler uscire?',
    deleteAccount: 'Elimina Account',
    deleteAccountConfirmation: 'Sei sicuro di voler eliminare il tuo account?',
    deleteAccountWarning: 'Questa azione non può essere annullata. Tutti i tuoi dati verranno eliminati definitivamente.',
    deleteAccountButton: 'Elimina il Mio Account',
    deleteAccountInputPlaceholder: 'Scrivi "delete" per confermare',
    deleteAccountInputError: 'Scrivi "delete" per confermare l\'eliminazione dell\'account',
    deleteAccountPasswordPlaceholder: 'Inserisci la tua password',
    deleteAccountPasswordRequired: 'La password è obbligatoria',
    changePassword: 'Cambia Password',
    changePasswordDescription: 'Aggiorna la password del tuo account',
    currentPassword: 'Password Attuale',
    newPassword: 'Nuova Password',
    confirmNewPassword: 'Conferma Nuova Password',
    passwordChanged: 'Password cambiata con successo',
    passwordChangeError: 'Errore nel cambio password',
    currentPasswordWrong: 'La password attuale è sbagliata',
    passwordChangedRedirect: 'Password cambiata con successo. Sarai reindirizzato al login.',
    socialLoginNoPassword: 'Questo profilo è stato creato tramite accesso con Google e non ha una password da cambiare.',
    accountDeactivated: 'Account disattivato',
    accountReactivated: 'Account riattivato con successo',
    // Address form
    personalAddress: 'Indirizzo Personale',
    address: 'Indirizzo',
    city: 'Città',
    postalCode: 'Codice Postale',
    country: 'Paese',
    phone: 'Telefono',
    edit: 'Modifica',
    add: 'Aggiungi',
    save: 'Salva',
    saving: 'Salvando...',
    addressUpdated: 'Indirizzo aggiornato con successo',
    addressUpdateError: 'Errore nell\'aggiornamento dell\'indirizzo',
    noAddressData: 'Nessuna informazione sull\'indirizzo disponibile',
    cancel: 'Annulla',
    confirm: 'Conferma'
};

export default account;
